import { Component, Input } from '@angular/core';
import { LayerViewModel } from '../view-models/layer-viewmodel';
import { TranslatePipe } from '@ngx-translate/core';
import { DateTimePipe } from '../utils/datetime.pipe';
import { DatePipe } from '@angular/common';
import { FixedFiltersComponent } from '../fixed-filters/fixed-filters.component';

@Component({
    selector: 'ecg-header-information',
    templateUrl: './header-information.component.html',
    styleUrls: ['./header-information.component.css'],
    standalone: true,
    imports: [TranslatePipe, DateTimePipe, DatePipe, FixedFiltersComponent],
})
export class HeaderInformationComponent {
    @Input()
    layer!: LayerViewModel;
}
